export const avatarColours: string[] = [
  'bg-turquoise-bright',
  'bg-turquoise-mid',
  'bg-blue-bright',
  'bg-blue-electric',
  'bg-blue-dark',
  'bg-blue-muted-dark',
  'bg-grey-blue',
];
